import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Logger, LoggingService } from '../../services/LoggingService';
import { SierraView } from './SierraView';
import { SierraViewError } from './SierraViewError';

export const SafeSierraView = () => {
  const logger: Logger = new LoggingService().getLogger('SafeSierraView');

  const errorHandler = (error: Error, info: { componentStack: string }) => {
    connect
      .getLog()
      .error('Sierra View pane error caught by error boundary')
      .withException(error);
    logger.error('Sierra View pane error caught by error boundary', { error });
  };

  return (
    <ErrorBoundary FallbackComponent={SierraViewError} onError={errorHandler}>
      <SierraView />
    </ErrorBoundary>
  );
};
